export default __webpack_public_path__ + "static/media/marc2b.93c8def3.jpg";